import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { DOMANDE } from './const'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import RadioWithState from '../commons/form/fieldWithState/RadioWithState'
import ScoreDialog from '../ScoreDialog'
import { Container } from '@material-ui/core'
import clsx from 'clsx'
import sbm from './../img/mental-wellness.jpg'
import logo from './../img/vyta-longevity-logo.png'
import viscontilogo from './../img/logo-colorato.png'

export default ({
    onClickReset,
    formProps,
    submitDisabled,
    score,
    classes
}) => <Container maxWidth="md" className={classes.root}>
        <Grid container spacing={2}>
            <Grid container item alignItems='center' justifyContent='space-between'>
                <Grid item xs={2}>
                    <a href="https://www.vytalongevity.com/"><img src={logo} alt={'VYTA Longevity'} className={classes.img} /></a>
                </Grid>
                <Grid item xs={4}>
                    <a href="https://www.visconti-neurologo.it"><img src={viscontilogo} alt={'Doot. Visconti - Neurologo'} className={classes.img} /></a>
                </Grid>
                <Grid item xs={2}>
                    <img src={sbm} alt={'mental wellness'} className={classes.img} />
                </Grid >
            </Grid>
            <Typography className={classes.title} style={{ marginTop: '70px' }}><i>{'"Perceived Stress Scale" di Sheldon Cohen'}</i></Typography>
            <Typography className={classes.title}>{'LA SCALA PER LO STRESS PERCEPITO'}</Typography>
            <Typography style={{ marginTop: '50px' }} gutterBottom={true}>{'Questo stress test utilizza la Perceived Stress Scale (PSS). Originariamente creato  da Cohen et al (1983), è uno strumento psicologico altamente riconosciuto per misurare la percezione dello stress, clinicamente convalidato e ampiamente utilizzato dal NHS-National Health Service inglese e da altri autorevoli servizi sanitari pubblici'}</Typography>
            <Typography gutterBottom={true}>{'Le domande riguardano i nostri sentimenti e pensieri durante l\'ultimo mese e pertanto viene  chiesto a chi compila il test di indicare quanto spesso si sia sentito o "pensato" in un certo modo.'} </Typography>
            <Typography gutterBottom={true}>{'Le domande sono declinate al maschile utilizzato come neutro.'}</Typography>
            <Typography gutterBottom={true}>{'Sebbene alcune domande siano simili, esistono differenze tra loro e vanno trattate come una domanda separata. L\'approccio migliore è rispondere abbastanza rapidamente: cioè, non provare a contare il numero di volte in cui ci si sia sentiti in un modo particolare ma piuttosto indicare l\'alternativa che sembri una stima ragionevole.'}</Typography>
            <Divider style={{ width: '100%', marginTop: '30px' }} />
            {DOMANDE.map((d, index) =>
                <Grid container item key={d.name} className={clsx(index < 9 && classes.borderbBottom, classes.domanda)}>
                    <Grid item sm={8}><Typography>{d.label}</Typography></Grid>
                    <Grid item sm={4}><RadioWithState
                        {...formProps}
                        name={d.name}
                        options={d.optionList}
                    /></Grid>
                </Grid>)}
            <Grid item>
                <ScoreDialog
                    openProps={{
                        variant: 'contained',
                        style: {
                            // float: 'right'
                        },
                        disabled: submitDisabled,
                        color: 'primary'
                    }}
                    score={score}
                    classes={classes}
                />
                <Button
                    onClick={onClickReset}
                >{'Reset'}</Button>
            </Grid>

        </Grid>

    </Container>